import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tags: {
    [BillingMode.Stripe]: 'Opłata z metody płatności',
    [BillingMode.InternalInvoicing]: 'Opłata ze sprzedaży',
    active: 'Aktywna',
    on_trial: 'Okres próbny',
    launch_pending: 'Wstrzymano do dnia uruchomienia',
    billing_disabled: 'Rozliczenia wyłączone',
    on_grace_period: 'Okres karencji',
    past_due: 'Zaległe',
    cancelled: 'Anulowana',
  },
};
